'use client'
import { useEffect, useState } from 'react';
import SidebarView from './sidebar-view';

export default function ClientOnlySidebar({ children }: { children: React.ReactNode }) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // During server-side rendering and initial client render, show a minimal layout
  if (!isHydrated) {
    return (
      <div style={{ padding: '20px' }}>
        {children}
      </div>
    );
  }

  // After hydration, show the full sidebar
  return (
    <SidebarView>
      {children}
    </SidebarView>
  );
}
